<template>
<div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Justificativas</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Nova" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>						
					</template>
				</Toolbar>

				<DataTable :value="justificativas" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="descricao" header="Descrição" sortable></Column>
					<Column field="descricaoTipo" header="Tipo" sortable></Column>				
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
						</template>
					</Column>
				</DataTable>

				<Dialog :visible.sync="exibirDialogCadastro" :header="tituloModal" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Descrição</label>
							<InputText id="descricao" v-model.trim="justificativaSelecionada.descricao" required="true" autocomplete="off" maxlength="80"/>
							<small class="p-invalid" v-if="enviandoForm && !justificativaSelecionada.descricao">Informe a descrição</small>
						</div>					
					</div>
					<div class="p-fluid">
						<div class="p-field-checkbox">
							<Checkbox v-model="justificativaSelecionada.inibirAcesso" :binary="true" />
    						<label for="binary">Inibir acessos</label>				
						</div>					
					</div>	
					<div class="p-field p-mt-2">
						<label class="p-mb-3">Tipo</label>
						<div class="p-field-radiobutton">
							<RadioButton id="tipo1" name="tipo" :value="1" v-model.number="justificativaSelecionada.tipo" />
							<label>Abonar horas</label>								
						</div>
						<div class="p-field-radiobutton">
							<RadioButton id="tipo2" name="tipo" :value="2" v-model.number="justificativaSelecionada.tipo" />
							<label>Explicação</label>												
						</div>
						<div class="p-field-radiobutton">
							<RadioButton id="tipo3" name="tipo" :value="3" v-model.number="justificativaSelecionada.tipo" />	
							<label>Compensação</label>											
						</div>
						<div class="p-field-radiobutton">
							<RadioButton id="tipo4" name="tipo" :value="4" v-model.number="justificativaSelecionada.tipo" />	
							<label>Inclusão de marcação</label>											
						</div>
						<div class="p-field-radiobutton">
							<RadioButton id="tipo5" name="tipo" :value="5" v-model.number="justificativaSelecionada.tipo" />	
							<label>Desconsiderar marcação</label>											
						</div>
					</div>				
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Salvar" icon="pi pi-check" @click="salvar"/>
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						<span>Excluir justificativa <b>{{ justificativaSelecionada.descricao }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>

			</div>
		</div>
	</div>  
</template>

<script>
import JustificativaService from '@/service/JustificativaService';
import Justificativa from '@/model//Justificativa';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
    justificativaService: null,
	data() {
		return {
			permissaoNovo: false,
			permissaoEditar: false,
			permissaoExcluir: false,
			tituloModal: 'Nova justificativa',
			exibirDialogConfirmarExcluir: false,
			exibirDialogCadastro: false,		
			enviandoForm: false,
			justificativaSelecionada: new Justificativa(),
			justificativas: [],		
			filtro: {}
		}
    },
    methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),		
		listar() {					
			this.justificativaService.listar({...this.getDadosRequisicao()})
				.then(resp => {
					this.justificativas = resp.data;
                })
                .catch(erro => {exibirMensagem(this, erro)});   
		},
		novo() {		
			this.tituloModal = 'Nova justificativa';	
			this.justificativaSelecionada = new Justificativa();
			this.exibirDialogCadastro = true;
			this.enviandoForm = false;
		},
		salvar() {
			this.enviandoForm = true;
			if(this.justificativaSelecionada.descricao != '') {
				let requisicao = {
					justificativa: {...this.justificativaSelecionada},
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}			
				this.justificativaService.salvar(requisicao)
					.then(resp => {	
						this.fecharModal();
						this.listar();						
						exibirMensagem(this, resp);						
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}

		},
		excluir() {
			let requisicao = {
				justificativa: {...this.justificativaSelecionada},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.justificativaService.excluir(requisicao)
				.then(resp => {	
					this.limparExcluir();
					this.listar();
					exibirMensagem(this, resp);						
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		editar(justificativa) {
			this.enviandoForm = false;
			let requisicao = {
				idJustificativa: justificativa.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.justificativaService.buscar(requisicao)
				.then(resp => {	
					this.tituloModal = 'Editar justificativa';
					this.justificativaSelecionada = resp.data;				
					this.exibirDialogCadastro = true;				
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		confirmarExcluir(justificativa) {
			this.justificativaSelecionada = justificativa;
			this.exibirDialogConfirmarExcluir = true;
		},
		limparExcluir() {
			this.justificativaSelecionada = new Justificativa();
			this.exibirDialogConfirmarExcluir = false;
		},
		fecharModal() {
			this.justificativaSelecionada = new Justificativa();
			this.exibirDialogCadastro = false;
			this.enviandoForm = false;
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(91);
			this.permissaoEditar = permissoes.includes(92);
			this.permissaoExcluir = permissoes.includes(93);			
		}
	},
	created() {
		this.justificativaService = new JustificativaService();		
	},
	mounted() {	
		this.validarPermissoes();	
		this.listar();
	}

}
</script>

<style>

</style>